module.exports = __webpack_public_path__ + "static/media/calendar.b99412ab.svg";